module.exports = __webpack_public_path__ + "img/hr-concrete-o.2664554c.png";